import { DailyCash, DailyCashCreate } from "../Components/index.js";

export default [
    { path: "/voucher/store/daily-cash", component: DailyCash, name: "voucher.store.daily.cash" },
    { path: "/voucher/store/daily-cash/entry", component: DailyCashCreate, name: "voucher.store.daily.cash.create" }
];
